import { useEffect, useState } from "react";
import { Loader2, Check } from "lucide-react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// Pick one or more images from the admin gallery library.
export default function GalleryPicker({ open, onOpenChange, onSelect, multiple = false }) {
  const [items, setItems] = useState(null);
  const [region, setRegion] = useState("All");
  const [picked, setPicked] = useState([]);

  useEffect(() => { if (open) { setPicked([]); api.get("/admin/gallery").then((r) => setItems(r.data || [])).catch(() => setItems([])); } }, [open]);

  const regions = ["All", "India", "International"];
  const shown = (items || []).filter((g) => region === "All" || (g.region || "India") === region);

  const toggle = (g) => {
    if (multiple) setPicked((p) => (p.includes(g.id) ? p.filter((x) => x !== g.id) : [...p, g.id]));
    else { onSelect(g.image); onOpenChange(false); }
  };
  const confirm = () => { picked.forEach((id) => { const g = (items || []).find((x) => x.id === id); if (g) onSelect(g.image); }); onOpenChange(false); };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85vh] max-w-3xl overflow-y-auto" aria-describedby={undefined} data-testid="gallery-picker">
        <DialogHeader><DialogTitle className="font-display text-2xl text-navy">Pick from Gallery</DialogTitle></DialogHeader>
        <div className="mb-3 flex gap-2">
          {regions.map((r) => <button key={r} type="button" onClick={() => setRegion(r)} data-testid={`picker-region-${r}`} className={`rounded-full px-4 py-1.5 text-xs font-bold ${region === r ? "brand-gradient text-white" : "border border-gray-200 text-navy"}`}>{r}</button>)}
        </div>
        {items === null ? <div className="grid grid-cols-3 gap-3">{Array.from({ length: 6 }).map((_, i) => <div key={i} className="h-28 skeleton rounded-xl" />)}</div>
          : shown.length === 0 ? <p className="py-10 text-center text-sm text-gray-500">No images in this category yet.</p>
            : (
              <div className="grid grid-cols-3 gap-3 sm:grid-cols-4">
                {shown.map((g) => {
                  const on = picked.includes(g.id);
                  return (
                    <button key={g.id} type="button" onClick={() => toggle(g)} data-testid={`picker-img-${g.id}`} className={`group relative overflow-hidden rounded-xl border-2 ${on ? "border-brandorange" : "border-transparent"}`}>
                      <img src={g.image} alt={g.title} className="h-24 w-full object-cover" />
                      {on && <span className="absolute right-1 top-1 rounded-full bg-brandorange p-1 text-white"><Check className="h-3 w-3" /></span>}
                      {g.destination && <span className="absolute bottom-0 w-full bg-black/50 px-1 py-0.5 text-[9px] text-white">{g.destination}</span>}
                    </button>
                  );
                })}
              </div>
            )}
        {multiple && <button type="button" onClick={confirm} data-testid="picker-confirm" className="btn-gradient mt-4 w-full rounded-full py-2.5 text-sm font-bold">Add {picked.length} selected</button>}
      </DialogContent>
    </Dialog>
  );
}
